module.exports = __webpack_public_path__ + "static/media/lyptus.4a6ec2ea.webp";